import getStateValue from '../../../helpers/getStateValue';

export default () => getStateValue(['apiUrls', 'analyticApiService'], '');
